module.exports = __webpack_public_path__ + "static/media/louyixiao.87d20996.png";